import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ActionPayload, DataLakeReprocessFailedFileRequestInput } from '../gql-types.generated';

export const MUTATION_REPROCESS_FILE = gql`
    mutation reprocessFailedDataLakeFile($input: DataLakeReprocessFailedFileRequestInput!){
        reprocessFailedDataLakeFile(input: $input){
            message
            result
            errors {
                code
                message
            }
        }
    }
`;

export const mutationReprocessDataLakeFile = async (
    client: ApolloClient<NormalizedCacheObject>,
    fileNamesWithFullPaths: string[]
): Promise<ActionPayload | undefined> => {
    const { data, errors } = await client.mutate<{ reprocessFailedDataLakeFile: ActionPayload }>({
        variables: { 
            input: {
                fileNamesWithFullPaths
            } as DataLakeReprocessFailedFileRequestInput
         },
        mutation: MUTATION_REPROCESS_FILE
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // friendly error to user
        throw new Error('An error has occurred during the reprocessing of failed or archived files.');
    }
    if (data && data.reprocessFailedDataLakeFile) {
        return data.reprocessFailedDataLakeFile;
    }

    return undefined;
};